export enum DebugInfoKey {
	WindowReloadTriggerEvents = "windowReloadTriggerEvents",
}

export enum WindowReloadReason {
	NA = 0,
	WindowEventOnline,
	SocketReconnecting,
	SwitchClient,
	OfflineDetector,
	ReloadAppClickWhenTeamsAppIsNotInitialized,
	CacheDeploymentFirstTime,
	CacheDeploymentSingleDeployment,
	CacheDeploymentSelectionMade,
	CacheDeploymentNoneFound,
	CacheDeploymentNotExistingAnymore,
	CacheDeploymentNoneSelected,
	CacheDeploymentCookieNoneFound,
	SocketClosed,
	HeartbeatTimeout,
}

export interface DebugInfoState {
	debugInfo: Record<string, any>;
}

export interface DebugInfoActions {
	pushDebugInfoItem: (key: DebugInfoKey, value: any) => void;
	removeDebugInfoItems: (keys: DebugInfoKey[]) => void;
}